import { type ContestSettings, ContestSegmentType } from '@betterpool/api-types/contests-service';
import type { Dispatch, SetStateAction } from 'react';

import { SegmentedControl } from '~/domains/common/components/SegmentedControl/SegmentedControl';

import type { SegmentTab } from './useSegmentedTabs';

type ScheduleTabsControlProps = {
  segments?: ContestSettings['segments'];
  tabs: {
    label: string;
    value: SegmentTab;
  }[];
  activeTab: SegmentTab;
  setActiveTab: Dispatch<SetStateAction<SegmentTab>>;
};

function ScheduleTabsControl({
  activeTab,
  setActiveTab,
  tabs,
  segments,
}: ScheduleTabsControlProps) {
  if (!segments || segments?.segmentType === ContestSegmentType.SINGLE_SLATE) return null;

  return (
    <SegmentedControl
      value={activeTab}
      onChange={(v) => {
        setActiveTab(v as SegmentTab);
      }}
      data={tabs.map(({ label, value }) => ({
        value,
        label,
      }))}
      w="100%"
      mb="lg"
    />
  );
}

export default ScheduleTabsControl;
